import React from "react";
import { Link } from "react-router-dom";
import { trackLinkClick } from "./lib/trackClick";
import { useSiteContent } from "./hooks/useSiteContent";

const Footer: React.FC = () => {
  const content = useSiteContent(
    [
      "footer_instagram_url",
      "footer_facebook_url",
      "footer_email",
      "footer_copyright",
    ],
    {
      footer_instagram_url: "https://www.instagram.com/permiasuiuc/?hl=en",
      footer_facebook_url:
        "https://www.facebook.com/checkpoint/1501092823525282/?next=https%3A%2F%2Fwww.facebook.com%2Fisc.uiuc%2F",
      footer_email: "permias.uiuc@gmail.com",
      footer_copyright:
        "© 2024 Indonesian Student Association at the University of Illinois Urbana-Champaign",
    }
  );

  return (
    <div className="flex flex-col items-center justify-between w-screen mx-auto text-white bg-red h-[150px]">
      <div className="flex justify-center w-full mt-[40px] space-x-14 md:space-x-14">
        <a
          href={content.footer_instagram_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackLinkClick("instagram")}
        >
          <img
            src={process.env.PUBLIC_URL + "/footer/instagram.svg"}
            alt="Instagram Logo"
            width={50}
            className="w-[35px] md:w-[50px]"
          />
        </a>
        <a
          href={content.footer_facebook_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackLinkClick("facebook")}
        >
          <img
            src={process.env.PUBLIC_URL + "/footer/facebook.svg"}
            alt="Facebook Logo"
            width={50}
            className="w-[35px] md:w-[50px]"
          />
        </a>
        <a
          href={`mailto:${content.footer_email}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackLinkClick("email")}
        >
          <img
            src={process.env.PUBLIC_URL + "/footer/mail.png"}
            alt="Email"
            width={50}
            className="w-[35px] md:w-[50px]"
          />
        </a>
        <Link to="/admin">
          <img
            src={process.env.PUBLIC_URL + "/footer/login.png"}
            alt="Admin"
            width={50}
            className="w-[35px] md:w-[50px]"
          />
        </Link>
      </div>
      <span className="mb-[15px] text-sm mx-[30px] text-center">
        {content.footer_copyright}
      </span>
    </div>
  );
};

export default Footer;
